import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { RegionComunaDTO } from "app/main/apps/shared/interfaces/region-comuna.interface";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-dialog-sucursal",
    templateUrl: "./dialog-sucursal.component.html",
    styleUrls: ["./dialog-sucursal.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogSucursalComponent implements OnInit, OnDestroy {
    regiones: RegionComunaDTO[];
    comunas: RegionComunaDTO[];
    subscripciones: Subscription;
    formSucursal: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogSucursalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _codigosSrvc: CodigosService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.initForm();
        //console.log(this.data);

        this.subscripciones.add(
            this._codigosSrvc.fetchRegiones().subscribe((resp) => {
                this.regiones = resp;
            })
        );

        if (this.data.editar) {
            this.subscripciones.add(
                this._codigosSrvc
                    .fetchComunasRegion(this.data.sucursal.comuna.region.id)
                    .subscribe((resp) => {
                        this.comunas = resp;
                    })
            );
        }
    }

    buscarComunas(event: MatSelectChange) {
        this.subscripciones.add(
            this._codigosSrvc
                .fetchComunasRegion(event.value)
                .subscribe((resp) => {
                    this.comunas = resp;
                    //console.log(resp);
                })
        );
    }

    initForm() {
        this.formSucursal = this.fb.group({
            nombre: [
                this.data?.sucursal?.nombre || null,
                { validators: [Validators.required] },
            ],
            direccion: [
                this.data?.sucursal?.direccion || null,
                { validators: [Validators.required] },
            ],
            idRegion: [
                this.data?.sucursal?.comuna?.region?.id || null,
                { validators: [Validators.required] },
            ],
            idComuna: [
                this.data?.sucursal?.comuna?.id || null,
                { validators: [Validators.required] },
            ],
            telefono: [
                this.data?.sucursal?.telefono || null,
                { validators: [Validators.required] },
            ],
        });
    }

    get nombre() {
        return this.formSucursal.get("nombre");
    }
    get direccion() {
        return this.formSucursal.get("direccion");
    }
    get idComuna() {
        return this.formSucursal.get("idComuna");
    }
    get idRegion() {
        return this.formSucursal.get("idRegion");
    }
    get telefono() {
        return this.formSucursal.get("telefono");
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
